<template>
  <div class="pa-4" style="background-color: #f4f6f9;">
    <v-main>
      <v-row style="justify-content: center;">
        <v-dialog
        v-model="dialogฺBranch"
        width="1000px"
        min-height="800px"
        >
        <v-card min-height="800px">
          <v-card-title>
            <v-toolbar
              dark
              color="#1b437c"
              elevation="0"
            >
              <v-toolbar-title><v-icon style="font-size: 40px;margin-right: 10px;">mdi-store</v-icon>ยอดขายแบ่งตามสาขา</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  dark
                  text
                  @click="filterDataSaleByBranch = [],valuesBranchAutocomplete = [],dialogฺBranch = false"
                >
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
          </v-card-title>
          <div>
            <!-- <p style="font-size: 20px;font-weight: bold;"><v-icon style="font-size: 40px;margin-right: 10px;">mdi-store</v-icon>ยอดขายแบ่งตามสาขา</p> -->
            <!-- {{ valuesBranchAutocomplete }} -->
            <!-- {{ column }} -->
          </div>
          <v-card-text  class="pa-4 pt-2">
            <div>
              <div style="padding: 10px;">
                <v-autocomplete
                  v-model="valuesBranchAutocomplete"
                  :items="itemsBranchAutocomplete"
                  outlined
                  dense
                  chips
                  hide-details
                  small-chips
                  label="ค้นหาสาขา"
                  multiple
                  @change="checkMoreOrLess"
                >
                <template v-slot:selection="data">
                  <v-chip
                    close
                    @click="data.select"
                    @click:close="remove(data.item)"
                  >
                    {{ data.item }}
                  </v-chip>
                </template></v-autocomplete>
              </div>
              <div class="pl-3">
                <p class="mb-1" style="font-size: 15px;font-weight: bold;">- เรียงข้อมูลตามยอดขาย</p>
                <v-radio-group
                  v-model="column"
                  row
                  class="mt-0"
                  @change="checkMoreOrLess"
                >
                  <v-radio
                    label="มากไปน้อย"
                    value="มากไปน้อย"
                  ></v-radio>
                  <v-radio
                    label="น้อยไปมาก"
                    value="น้อยไปมาก"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
            <div style="font-size: 18px;margin-bottom: 10px;margin-top: 15px;"><v-icon style="font-size: 40px;">mdi-cash</v-icon> ยอดขายทั้งหมด {{ formatNumber(amount ? amount: amountSales1) }} บาท</div>
            <div>
              <v-row class="pa-1">
                <v-col cols="4"  v-for="(item, i) in filterDataSaleByBranch" :key="i" v-if="valuesBranchAutocomplete.length > 0">
                  <v-card class="pa-3">
                    <div style="display:flex;justify-content: space-evenly;">
                      <v-avatar color="primary">
                        <div style="">
                          <v-icon dark size="36">
                            mdi-storefront
                          </v-icon>
                        </div>
                      </v-avatar>
                      <div class="ml-3">
                        <p class="mb-0">{{ item.masBranchName }}</p>
                        <p class="mb-0">{{ formatNumber(item.amount) }} บาท</p>
                        <p class="mb-0">คิดเป็น {{ calPercent(amount ? amount: amountSales1, item.amount) }}% ขายทั้งหมด</p>
                        <v-progress-linear color="green" :value="calPercent(amount ? amount: amountSales1, item.amount)"></v-progress-linear>
                      </div>
                      <div style="display: flex;align-items: center;">
                        <v-btn small fab color="#cbcbcb" elevation="0" dark @click="exportData(item)"><v-icon>mdi-export</v-icon></v-btn>
                      </div>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="4"  v-for="(item, i) in dataSaleByBranch" :key="i" v-if="valuesBranchAutocomplete.length <= 0">
                  <v-card class="pa-3">
                    <div style="display:flex;justify-content: space-evenly;">
                      <v-avatar color="primary">
                        <div style="">
                          <v-icon dark size="36">
                            mdi-storefront
                          </v-icon>
                        </div>
                      </v-avatar>
                      <div class="ml-3" style="flex: 1">
                        <p class="mb-0">{{ item.masBranchName }}</p>
                        <p class="mb-0">{{ formatNumber(item.amount.toFixed(2)) }} บาท</p>
                        <p class="mb-0">คิดเป็น {{ calPercent(amount ? amount: amountSales1, item.amount) }}%</p>
                        <v-progress-linear color="green" :value="calPercent(amount ? amount: amountSales1, item.amount)"></v-progress-linear>
                      </div>
                      <div style="display: flex;align-items: center;">
                        <v-btn small fab color="#cbcbcb" elevation="0" dark @click="exportData(item)"><v-icon style="font-size: 20px;">mdi-export</v-icon></v-btn>
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
        <v-col class="pl-7 pb-2 pt-4" >
          <h1><v-icon class="mr-4" style="font-size: 40px;">mdi-monitor-dashboard</v-icon> Dashboard</h1>
        </v-col>
        <!-- <v-btn @click="test()">ok</v-btn> -->
        <v-col
          class="pt-3 pb-0"
          cols="3"
        >
          <v-select
          v-model="typeFilter"
          :items="type"
          label="เลือกประเภทตัวกรองข้อมูล"
          hide-details
          outlined
          dense
          @change="checkTypeFilter(typeFilter)"
          style="background-color: white;padding: 0px !important;"
          ></v-select>
        </v-col>
        <v-col
          class="pt-3 pb-0"
          cols="3"
        >
          <v-select
          :items="itemFilter"
          v-model="filter"
          dense
          label="รายละเอียดตัวกรองข้อมูล"
          hide-details
          style="background-color: white;padding: 0px !important;"
          outlined
          @change="checkFilter()"
          ></v-select>
        </v-col>
      </v-row>
      <v-dialog
        v-model="dialogDate"
        :width="showCalendar2 ? '700' : '500'"
      >
        <v-card class="pa-4">
          <v-card-title style="font-weight: bold;margin-bottom: 5px;justify-content: space-between;">
            <p class="mb-0"><v-icon style="font-size: 35px;">mdi-calendar-search</v-icon> ค้นหาแบบระบุวันที่</p>
            <v-btn
              color="#DB005B"
              icon
              @click="closeDialogDate"
              large
            ><v-icon>mdi-close-circle-outline</v-icon></v-btn>
          </v-card-title>
          <v-checkbox
            v-model="showCalendar2"
            :value="true"
            label="เทียบข้อมูลระบุวันที่"
            off-icon="mdi-checkbox-blank-circle-outline"
            on-icon="mdi-checkbox-marked-circle"
          ></v-checkbox>
            <v-card :class="showCalendar2 ? 'mb-0 pa-2' : 'mb-3 pa-2'" elevation="1">
              <div class="centerText">
                <div class="mr-3" style="display: flex;">
                  <v-icon class="mr-1">mdi-calendar-month</v-icon><p class="mb-0">ข้อมูลวันที่</p>
                </div>
                <div class="centerText">
                  <p class="mb-0" v-if="dates">{{ dates[0] }}</p>
                  <p v-if="dates" class="mx-3 mb-0 centerText">ถึง</p>
                  <p class="mb-0" v-if="dates">{{ dates[1] }}</p>
                </div>
              </div>
              <!-- <div v-if="dates2" style="display: flex;justify-content: center;">เทียบกับ</div>
                <div v-if="dates">
                  <div style="display: flex;justify-content: center;">
                    <div class="mr-3 centerText">
                      <p class="mb-0"><v-icon class="mr-1">mdi-calendar-month</v-icon> ข้อมูลวันที่</p>
                    </div>
                  <div class="centerText">
                    <p class="mb-0" v-if="dates">{{ dates[0] }}</p>
                    <p class="mx-3 mb-0 centerText">ถึง</p>
                    <p class="mb-0" v-if="dates">{{ dates[1] }}</p>
                  </div>
                </div>
              </div> -->
            </v-card>
            <div v-if="showCalendar2" style="text-align: center;padding: 10px;">เทียบกับข้อมูลวันที่</div>
            <v-card v-if="showCalendar2" class="mb-2 pa-2" elevation="1">
              <div class="centerText">
                <div class="mr-3" style="display: flex;">
                  <v-icon class="mr-1">mdi-calendar-month</v-icon><p class="mb-0">ข้อมูลวันที่</p>
                </div>
                <div class="centerText">
                  <p class="mb-0" v-if="dates2">{{ dates2[0] }}</p>
                  <p v-if="dates" class="mx-3 mb-0 centerText">ถึง</p>
                  <p class="mb-0" v-if="dates2">{{ dates2[1] }}</p>
                </div>
              </div>
            </v-card>
            <v-row>
              <v-col
                :cols="showCalendar2 ? '6' : '12'"
              >
                <v-date-picker
                  v-model="dates"
                  range
                  elevation="1"
                  no-title
                ></v-date-picker>
              </v-col>
              <v-col
                v-if="showCalendar2"
                :cols="showCalendar2 ? '6' : '12'"
              >
                <v-date-picker
                  v-model="dates2"
                  range
                  elevation="1"
                  no-title
                ></v-date-picker>
              </v-col>
            </v-row>

          <div class="mt-5">
            <!-- <v-btn
              color="primary"
              block
              @click="showCalendar2 = !showCalendar2"
              class="mb-3"
            >
            <v-icon>mdi-compare-horizontal</v-icon> เทียบข้อมูลระบุวันที่
            </v-btn> -->
            <v-btn
              color="primary"
              block
              :disabled="!dates || dates.length === 1"
              @click="filterFunc"
            >
            <v-icon>mdi-clipboard-text-search-outline</v-icon> ค้นหา
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <!-- <v-row>
        <v-spacer></v-spacer>
        <v-col
          cols="12"
          sm="6"
          md="4"
        >
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date"
                label="Picker in menu"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu.save(date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="4"
        >
          <v-dialog
            ref="dialog"
            v-model="modal"
            :return-value.sync="date"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date"
                label="Picker in dialog"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="modal = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dialog.save(date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row> -->
      <div>
        <v-row>
          <v-col cols="3" >
            <div class="container-overview">
              <div style="display: flex;justify-content: space-between;">
                <p style="font-weight: bolder;">
                  ยอดขายทั้งหมด
                </p>
                <v-btn
                  color="#1b437c"
                  fab
                  dark
                  elevation="0"
                >
                  <v-icon style="color: white;font-size: 40px;">mdi-cash</v-icon>
                </v-btn>
              </div>
              <div style="font-size: 20px;font-weight: bolder;">
                {{ formatNumber(amount ? amount: amountSales1 ) }} ฿
                <v-icon v-if="filter !== null && show === true" :style="'color:' + trendUpSales + ';font-size: 30px;'">{{trendMember('sales')}}</v-icon>
              </div>
              <div v-if="filter !== null">
                <div v-if="trendUpSales === 'green'" style="color:green;display:flex">+ {{  formatNumber(parseFloat(diffPercentSales).toFixed(2)) }}<div v-if="amountSales2 !== 0" class="ml-1">%</div></div>
                <div v-else-if="trendUpSales === 'red'" style="color:red;display:flex">{{ formatNumber(parseFloat(diffPercentSales).toFixed(2)) }} <div v-if="amountSales2 !== 0" class="ml-1">%</div></div>
                <div v-else-if="trendUpSales === 'grey'" style="color:grey;display:flex">+ {{ formatNumber(parseFloat(diffPercentSales).toFixed(2)) }} <div v-if="amountSales2 !== 0" class="ml-1">%</div></div>
                <div v-if="!specificDate">เมื่อเทียบ {{ numfilter }} {{ nameFilter }}</div>
                <div v-if="specificDate">เมื่อเทียบ
                   <div>
                    {{ dateShow }} - {{ dateShow2 }}
                   </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="3" >
            <div class="container-overview">
              <div style="display: flex;justify-content: space-between;">
                <p style="font-weight: bolder;">
                  จำนวนสมาชิกทั้งหมด
                </p>
                <v-btn
                  color="#1b437c"
                  fab
                  dark
                  elevation="0"
                >
                  <v-icon style="color: white;font-size: 40px;">mdi-account-group</v-icon>
                </v-btn>
              </div>
              <div style="font-size: 20px;font-weight: bolder;">
                {{ formatNumber(countMember ? countMember: countMemberSet1 ) }} คน <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                        >
                        <download-excel
                                class="btn btn-default text-white"
                                :data="export_data_allMember"
                                :fields="export_fields"
                                :type="exportType"
                                :worksheet="exportWorksheet"
                                :name="exportFileName"
                              >
                              <v-icon style="color:rgb(117, 117, 117)"> mdi-download </v-icon>
                          </download-excel>
                        </v-btn>
                      </template>
                      <span>export</span>
                  </v-tooltip>
                <v-icon v-if="filter !== null && show === true" :style="'color:' + trendUpMember + ';font-size: 30px;'">{{trendMember('member')}}</v-icon>
              </div>
              <div v-if="filter !== null">
                <div v-if="trendUpMember === 'green'" style="color:green;display:flex">+ {{ formatNumber(parseFloat(diffPercentMember).toFixed(2)) }}<div v-if="countMemberSet2 !== 0" class="ml-1">%</div></div>
                <div v-else-if="trendUpMember === 'red'" style="color:red;display:flex">- {{ formatNumber(parseFloat(diffPercentMember).toFixed(2)) }}<div v-if="countMemberSet2 !== 0" class="ml-1">%</div></div>
                <div v-else-if="trendUpMember === 'grey'" style="color:grey;display:flex">+ {{ formatNumber(parseFloat(diffPercentMember).toFixed(2)) }}<div v-if="countMemberSet2 !== 0" class="ml-1">%</div></div>
                <div v-if="!specificDate">เมื่อเทียบ {{ numfilter }} {{ nameFilter }}</div>
                <div v-if="specificDate">เมื่อเทียบ
                   <div>
                    {{ dateShow }} - {{ dateShow2 }}
                   </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="3" v-if="typeFilter !== 'ทั้งหมด'">
            <div class="container-overview">
              <div style="display: flex;justify-content: space-between;">
                <p style="font-weight: bolder;">
                  ลูกค้าใหม่เข้าใช้บริการ
                </p>
                <v-btn
                  color="#1b437c"
                  fab
                  dark
                  elevation="0"
                >
                  <v-icon style="color: white;font-size: 40px;">mdi-account-plus</v-icon>
                </v-btn>
              </div>
              <div style="font-size: 20px;font-weight: bolder;" >
                {{ newMemberSet1 }} คน
                <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                        >
                        <download-excel
                                class="btn btn-default text-white"
                                :data="export_data_newMember"
                                :fields="export_fields"
                                :type="exportType"
                                :worksheet="exportWorksheet"
                                :name="exportFileName"
                              >
                              <v-icon color="#757575"> mdi-download </v-icon>
                          </download-excel>
                        </v-btn>
                      </template>
                      <span>export</span>
                  </v-tooltip>
                <v-icon v-if="filter !== null" :style="'color:' + trendUpNewMember + ';font-size: 30px;'">{{trendMember('newMember')}}</v-icon>
              </div>
              <div v-if="filter !== null">
                <div v-if="trendUpNewMember === 'green'" style="color:green;display:flex">+ {{ formatNumber(parseFloat(diffPercentNewMember).toFixed(2)) }}<div v-if="newMemberSet2 !== 0" class="ml-1">%</div></div>
                <div v-else-if="trendUpNewMember === 'red'" style="color:red;display:flex"> {{ formatNumber(parseFloat(diffPercentNewMember).toFixed(2)) }}<div v-if="newMemberSet2 !== 0" class="ml-1">%</div></div>
                <div v-else-if="trendUpNewMember === 'grey'" style="color:grey;display:flex">+ {{ formatNumber(parseFloat(diffPercentNewMember).toFixed(2)) }}<div v-if="newMemberSet2 !== 0" class="ml-1">%</div></div>
                <div v-if="!specificDate">เมื่อเทียบ {{ numfilter }} {{ nameFilter }}</div>
                <div v-if="specificDate">เมื่อเทียบ
                   <div>
                    {{ dateShow }} - {{ dateShow2 }}
                   </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="3" v-if="typeFilter !== 'ทั้งหมด'">
            <div class="container-overview">
              <div style="display: flex;justify-content: space-between;">
                <p style="font-weight: bolder;">
                  ลูกค้าเก่าเข้าใช้บริการ
                </p>
                <v-btn
                  color="#1b437c"
                  fab
                  dark
                  elevation="0"
                >
                  <v-icon style="color: white;font-size: 40px;">mdi-account</v-icon>
                </v-btn>
              </div>
              <div style="font-size: 20px;font-weight: bolder;">
                {{ oldMemberSet1 }} คน <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                        >
                        <download-excel
                                class="btn btn-default text-white"
                                :data="export_data_oldMember"
                                :fields="export_fields"
                                :type="exportType"
                                :worksheet="exportWorksheet"
                                :name="exportFileName"
                              >
                              <v-icon color="#757575"> mdi-download </v-icon>
                          </download-excel>
                        </v-btn>
                      </template>
                      <span>export</span>
                  </v-tooltip>
                <v-icon v-if="filter !== null" :style="'color:' + trendUpOldMember + ';font-size: 30px;'">{{trendMember('oldMember')}}</v-icon>
              </div>
              <div v-if="filter !== null">
                <div v-if="trendUpOldMember === 'green'" style="color:green;display:flex">+ {{ formatNumber(parseFloat(diffPercentOldMember).toFixed(2)) }}<div v-if="oldMemberSet2 !== 0" class="ml-1">%</div></div>
                <div v-else-if="trendUpOldMember === 'red'" style="color:red;display:flex"> {{ formatNumber(parseFloat(diffPercentOldMember).toFixed(2)) }}<div v-if="oldMemberSet2 !== 0" class="ml-1">%</div></div>
                <div v-else-if="trendUpOldMember === 'grey'" style="color:grey;display:flex">+ {{ formatNumber(parseFloat(diffPercentOldMember).toFixed(2)) }}<div v-if="oldMemberSet2 !== 0" class="ml-1">%</div></div>
                <div v-if="!specificDate">เมื่อเทียบ {{ numfilter }} {{ nameFilter }}</div>
                <div v-if="specificDate">เมื่อเทียบ
                   <div>
                    {{ dateShow }} - {{ dateShow2 }}
                   </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="3" v-if="typeFilter === 'ทั้งหมด'">
            <div class="container-overview">
              <div style="display: flex;justify-content: space-between;">
                <p style="font-weight: bolder;">
                  ลูกค้าใช้บริการครั้งเดียว
                </p>
                <v-btn
                  color="#1b437c"
                  fab
                  dark
                  elevation="0"
                >
                  <v-icon style="color: white;font-size: 40px;">mdi-account</v-icon>
                </v-btn>
              </div>
              <div style="font-size: 20px;font-weight: bolder;">
                <div>
                  {{ buyOnesMember }} คน
                  <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                        >
                        <download-excel
                                class="btn btn-default text-white"
                                :data="export_data_buyOneMember"
                                :fields="export_fields"
                                :type="exportType"
                                :worksheet="exportWorksheet"
                                :name="exportFileName"
                              >
                              <v-icon color="#757575"> mdi-download </v-icon>
                          </download-excel>
                        </v-btn>
                      </template>
                      <span>export</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="3" v-if="typeFilter === 'ทั้งหมด'">
            <div class="container-overview">
              <div style="display: flex;justify-content: space-between;">
                <p style="font-weight: bolder;">
                  ลูกค้าใช้บริการซ้ำ
                </p>
                <v-btn
                  color="#1b437c"
                  fab
                  dark
                  elevation="0"
                >
                  <v-icon style="color: white;font-size: 40px;">mdi-account</v-icon>
                </v-btn>
              </div>
              <div style="font-size: 20px;font-weight: bolder;">
                {{ buyRepeatMember }} คน
                <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                        >
                        <download-excel
                                class="btn btn-default text-white"
                                :data="export_data_buyRepeatMember"
                                :fields="export_fields"
                                :type="exportType"
                                :worksheet="exportWorksheet"
                                :name="exportFileName"
                              >
                              <v-icon color="#757575"> mdi-download </v-icon>
                          </download-excel>
                        </v-btn>
                      </template>
                      <span>export</span>
                  </v-tooltip>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
      <v-row>
        <v-col cols="6" class="pb-0">
          <div style="display: flex;justify-content: space-between;">
            <p class="mb-0" style="font-weight: bolder;font-size: 18px;"><v-icon class="mr-1">mdi-chart-areaspline</v-icon>ยอดขาย</p>
            <!-- <div class="text-center">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="grey"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    icon
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in items"
                    :key="index"
                    style="background-color: white !important;"
                  >
                    <v-list-item-title dark style="color:black !important">{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div> -->
          </div>
          <v-card elevation="0" style="height:300px;padding:0px;background-color: #ffffff00;justify-content: center;align-items: center;justify-content: center;display: flex;">
            <!-- <p class="mb-0" style="font-weight: bolder;font-size: 18px;">แนวโน้มยอดขาย</p> -->
            <v-progress-circular
              indeterminate
              color="blue"
              v-show="showChartSales === false"
            ></v-progress-circular>
            <canvas id="myChart" style="padding-bottom: 20px;" v-show="showChartSales === true"></canvas>
          </v-card>
        </v-col>
        <v-col cols="6" class="pb-0">
          <div>
            <p class="mb-0" style="font-weight: bolder;font-size: 18px;">ยอดขายแบ่งตามบริการ</p>
          </div>
          <!-- <p class="mb-0" style="font-weight: bolder;font-size: 18px;">แนวโน้มยอดขาย</p> -->
          <v-card elevation="0" style="height:300px;padding:0px;background-color: #ffffff00;justify-content: center;align-items: center;justify-content: center;display: flex;">
            <canvas id="myChartline" style="padding-top: 20px;" v-show="showChartSales === true"></canvas>
          </v-card>
        </v-col>
      </v-row>
      <!-- dfdfdf -->
      <v-row>
        <v-col cols="6">
          <div style="display: flex;justify-content: space-between;">
            <div style="font-weight: bolder;font-size: 18px;" v-if="checkMoreBranchten"><v-icon class="mr-1">mdi-storefront</v-icon> 10 สาขาขายดี</div>
            <div style="font-weight: bolder;font-size: 18px;" v-if="!checkMoreBranchten"><v-icon class="mr-1">mdi-storefront</v-icon> ยอดขายแบ่งตามสาขา</div>
            <p class="mb-0" style="font-size: 14px;padding-top: 4px;text-decoration: underline;color: cornflowerblue;" @click="dialogฺBranch = true">ดูเพิ่มเติม</p>
          </div>
          <!-- <div style="display: flex;justify-content: space-between;" v-if="!checkMoreBranchten">
            <div style="font-weight: bolder;font-size: 18px;"><v-icon class="mr-1">mdi-storefront</v-icon>ยอดขายแบ่งตามสาขา</div>
          </div> -->
          <v-card elevation="0" style="height:300px;padding:10px" >
            <canvas id="myChartBar" style="padding-top: 20px;overflow-x: auto;" v-show="showChartSales === true"></canvas>
          </v-card>
        </v-col>
        <v-col cols="3">
          <div style="display: flex;justify-content: space-between;">
            <div>
              <p class="mb-0" style="font-weight: bolder;font-size: 18px;">แจกคะแนนตามบริการ</p>
            </div>
          </div>
          <v-card elevation="0" style="height:300px;padding:20px">
            <canvas id="myChartDoughnut"></canvas>
          </v-card>
        </v-col>
        <v-col cols="3">
          <div style="font-weight: bolder;font-size: 18px;"><v-icon class="mr-1">mdi-card-account-details-star</v-icon>ระดับสมาชิก</div>
          <v-card elevation="0" style="height:300px;padding:20px">
             <canvas id="myChartArea"></canvas>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar
        v-model="snackbar"
        vertical
        :top="true"
      >
        <div class="text-subtitle-1 pb-2">ต้องการ export ข้อมูล{{ textExport }} <div style="color: green">{{ textTypeExport }}</div>ใช่หรือไม่ ?</div>

        <v-btn
            color="indigo"
            variant="text"
            class="mr-2"
        >
        <download-excel
                class="btn btn-default text-white"
                :data="export_data"
                :fields="export_fields"
                :type="exportType"
                :worksheet="exportWorksheet"
                :name="exportFileName"
              >
                Export Data
          </download-excel>
        </v-btn>
        <v-btn
            color="indigo"
            variant="text"
            @click="snackbar = false"
        >
            Close
        </v-btn>
        <!-- <template v-slot:actions>
          <v-btn
            color="indigo"
            variant="text"
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </template> -->
      </v-snackbar>
      <!-- dfdfdf -->
    </v-main>
  </div>
</template>
<script>
import Chart from 'chart.js'
// import LineChart from './LineChart.vue'
import moment from 'moment' // แปลง date
import axios from 'axios'
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
// import Home from '../Core/Home.vue'
export default {
  components: {
    downloadExcel: JsonExcel,
    XLSX
  },
  data () {
    return {
      dateShow: null,
      dateShow2: null,
      dates: null,
      dates2: null,
      session: this.$session.getAll(),
      type: ['ทั้งหมด', 'แบบระบุวันที่', 'รายสัปดาห์', 'รายเดือน', 'รายปี'],
      typeFilter: 'ทั้งหมด',
      itemFilter: [],
      dialogDate: false,
      filter: null,
      numfilter: null,
      shopAdmin: null,
      shopId: this.$session.getAll().data.shopId,
      lastClickTime: 0,
      startDaySet1: null,
      endDaySet1: null,
      startDaySet2: null,
      endDaySet2: null,
      amount: null,
      countMember: null,
      itemsBranchAutocomplete: [],
      valuesBranchAutocomplete: [],
      column: 'มากไปน้อย',
      salesData: null,
      countMemberSet1: null,
      countMemberSet2: null,
      dataMember: null,
      trendUpMember: null,
      diffPercentMemberL: null,
      amountSales1: null,
      amountSales2: null,
      trendUpSales: null,
      diffPercentSales: null,
      dialogฺBranch: false,
      countReward: null,
      show: false,
      showChartSales: false,
      power: 100,
      checkMoreBranchten: null,
      items: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' }
      ],
      myChartSales: null,
      myChartSalesBranch: null,
      myChartGivepointsbyservice: null,
      myChartLevelMember: null,
      myChartSalesService: null,
      branchIdGlobal: null,
      showCalendar2: false,
      specificDate: false,
      oldMemberSet1: 0,
      oldMemberSet2: 0,
      newMemberSet1: 0,
      newMemberSet2: 0,
      trendUpOldMember: null,
      trendUpNewMember: null,
      diffPercentOldMember: null,
      diffPercentNewMember: null,
      buyRepeatMember: 0,
      buyOnesMember: 0,
      dataBuyOnesMember: [],
      export_data_buyOneMember: null,
      export_data_buyRepeatMember: null,
      export_data_allMember: null,
      export_data_newMember: null,
      export_data_oldMember: null,
      dataBuyRepeatsMember: [],
      snackbar: false,
      textExport: '',
      textTypeExport: '',
      export_data: null,
      exportType: 'xls',
      exportFileName: 'System-User-Account.xls',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        lineUserId: 'lineUserId',
        liffUserId: 'liffUserId',
        ชื่อไลน์: 'name',
        picture: 'picture',
        ชื่อ: 'nameCustomer',
        เพศ: 'gender',
        วันเกิด: 'birthDay',
        เบอร์โทร: 'tel',
        ระดับสมาชิก: 'levelName'
      },
      dataSaleByBranch: [],
      filterDataSaleByBranch: []
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    this.$session.getAll().data.userTypeGroup !== 'Shop Admin' ? this.shopAdmin = false : this.shopAdmin = true
    console.log('test')
    await this.checkFilter()
    console.log('test22222')
    let today = moment().format('YYYY-MM-DD')
    console.log(this.salesData)
    this.renderChartSales()
    this.renderChartSalesService()
    this.renderChartSalesBranch()
    this.renderChartGivepointsbyservice()
    this.renderChartLevelMember()
    console.log('today', today)
    console.log('fffff', moment(today).subtract(2, 'weeks').add(1, 'days').format('YYYY-MM-DD'))
    // const ctx = document.getElementById('myChart').getContext('2d')
    // const myChart = new Chart(ctx, {
    //   type: 'line',
    //   data: {
    //     labels: this.type,
    //     datasets: [{
    //       label: 'test',
    //       data: [10, 20, 30, 40, 50, 60, 70, 10, 20, 30, 40, 50, 60, 70, 10, 20, 30, 40, 50, 60, 70, 10, 20, 30, 40, 50, 60, 70],
    //       backgroundColor: 'transparent',
    //       pointBackgroundColor: 'rgba(255, 99, 132, 1)',
    //       borderColor: 'rgba(255, 99, 132, 1)',
    //       borderWidth: 2,
    //       pointStyle: 'circle',
    //       lineTension: 0.1
    //     }]
    //   },
    //   options: {
    //     responsive: true,
    //     maintainAspectRatio: false,
    //     plugins: {
    //       datalabels: {
    //         display: false
    //       }
    //     },
    //     pointLabelFontSize: 0,
    //     scales: {
    //       xAxes: [{
    //         gridLines: {
    //           color: 'rgba(0, 0, 0, 0)'
    //         },
    //         ticks: {
    //           autoSkip: true,
    //           maxTicksLimit: 4
    //         }
    //       }],
    //       yAxes: [{
    //         gridLines: {
    //           color: 'rgba(0, 0, 0, 0)'
    //         },
    //         ticks: {
    //           beginAtZero: false,
    //           autoSkip: true,
    //           maxTicksLimit: 6
    //         }
    //       }]
    //     }
    //   }
    // })
    // console.log(myChart)
  },
  methods: {
    remove (item) {
      console.log(item)
      const index = this.valuesBranchAutocomplete.indexOf(item)
      if (index >= 0) this.valuesBranchAutocomplete.splice(index, 1)
      this.checkMoreOrLess()
    },
    closeDialogDate () {
      this.typeFilter = null
      this.dialogDate = false
      this.dates = null
      this.dates2 = null
      this.showCalendar2 = false
    },
    async getDatawithBranchID (filter) { // get data เป็น operation มี id สาขา
      let dataQrcode = axios.get(this.DNS_IP + '/PackageLog/get?shopId=' + this.$session.getAll().data.shopId)
      console.log('dataQrcode', dataQrcode)
    },
    async checkFilter () {
      if (this.typeFilter !== 'ทั้งหมด') {
        let today = moment().format('YYYY-MM-DD')
        let numfilter2 = parseInt(this.filter.split(' ')[1])
        this.nameFilter = this.filter.split(' ')[2]
        let startDaySet1 = null
        let endDaySet1 = null
        let startDaySet2 = null
        let endDaySet2 = null
        // console.log(moment(today).subtract(2, 'weeks').add(1, 'days').format('YYYY-MM-DD'))
        if (this.typeFilter === 'รายสัปดาห์') {
          startDaySet1 = today
          endDaySet1 = moment(today).subtract(numfilter2, 'weeks').add(1, 'days').format('YYYY-MM-DD')
          startDaySet2 = moment(today).subtract(numfilter2, 'weeks').format('YYYY-MM-DD')
          endDaySet2 = moment(startDaySet2).subtract(numfilter2, 'weeks').add(1, 'days').format('YYYY-MM-DD')
          console.log(startDaySet1)
          console.log(endDaySet1)
          console.log(startDaySet2)
          console.log(endDaySet2)
        } else if (this.typeFilter === 'รายเดือน') {
          startDaySet1 = today
          endDaySet1 = moment(today).subtract(numfilter2, 'months').format('YYYY-MM-DD')
          startDaySet2 = moment(today).subtract(numfilter2, 'months').subtract(1, 'days').format('YYYY-MM-DD')
          endDaySet2 = moment(startDaySet2).subtract(numfilter2, 'months').add(1, 'days').format('YYYY-MM-DD')
          console.log(startDaySet1)
          console.log(endDaySet1)
          console.log(startDaySet2)
          console.log(endDaySet2)
        } else {
          startDaySet1 = today
          endDaySet1 = moment(today).subtract(numfilter2, 'years').format('YYYY-MM-DD')
          startDaySet2 = moment(today).subtract(numfilter2, 'years').format('YYYY-MM-DD')
          endDaySet2 = moment(startDaySet2).subtract(numfilter2, 'years').format('YYYY-MM-DD')
          console.log(startDaySet1)
          console.log(endDaySet1)
          console.log(startDaySet2)
          console.log(endDaySet2)
        }
        // console.log(this.numfilter)
        // console.log(this.typeFilter)
        if (this.shopAdmin === true) {
          await this.getDatafilter(startDaySet1, endDaySet1, startDaySet2, endDaySet2)
          this.specificDate = false
        } else if (this.shopAdmin === false) {
          let branchId = this.$session.getAll().data.masBranchID
          this.branchIdGlobal = this.$session.getAll().data.masBranchID
          await this.getDatafilter(startDaySet1, endDaySet1, startDaySet2, endDaySet2, branchId)
          this.specificDate = false
        }
        this.numfilter = parseInt(this.filter.split(' ')[1])
        this.nameFilter = this.filter.split(' ')[2]
      } else {
        if (this.shopAdmin === true) {
          await this.getAllData()
        } else if (this.shopAdmin === false) {
          let branchId = this.$session.getAll().data.masBranchID
          await this.getAllData(branchId)
        }
        if (this.filter) {
          this.numfilter = parseInt(this.filter.split(' ')[1])
          this.nameFilter = this.filter.split(' ')[2]
        }
      }
      // axios.get(this.DNS_IP + '/qrcode/get?shopId=' + this.$session.getAll().data.shopId + '&status=used').then(res => {
      //   let dataItem = res.data

      //   console.log('res', dataItem)
      // })
    },
    async checkTypeFilter (a) {
      console.log(a)
      this.itemFilter = []
      if (a === 'ทั้งหมด') {
        console.log(a)
        this.filter = null
        await this.checkFilter()
      } else if (a === 'รายสัปดาห์') {
        for (let i = 1; i <= 3; i++) {
          this.itemFilter.push(`เทียบกับ ${i} สัปดาห์ที่แล้ว`)
        }
      } else if (a === 'รายเดือน') {
        for (let i = 1; i <= 11; i++) {
          this.itemFilter.push(`เทียบกับ ${i} เดือนที่แล้ว`)
        }
      } else if (a === 'รายปี') {
        for (let i = 1; i <= 5; i++) {
          this.itemFilter.push(`เทียบกับ ${i} ปีที่แล้ว`)
        }
      } else if (a === 'แบบระบุวันที่') {
        this.typeFilter = 'ทั้งหมด'
        this.dialogDate = true
        // console.log('แบบระบุวันที่่ja')
      }
    },
    async getAllData (branchId) {
      console.log('branchId', branchId)
      // get ยอดขาย
      let params = branchId ? '&masBranchID=' + branchId : ''
      await axios.get(this.DNS_IP + '/qrcode/get?shopId=' + this.shopId + '&status=used' + params).then(res => {
        console.log(res.data)
        this.salesData = res.data
        console.log('salesData', this.salesData)
        if (Array.isArray(res.data)) {
          this.amount = res.data.reduce(
            (accumulator, currentValue) => accumulator + currentValue.amount,
            0
          ).toFixed(2)
          this.updateSaleChartData()
          this.updateChartSalesBranch()
          this.updateChartSalesService()
          this.updateChartGivepointsbyservice()
        } else {
          this.amount = 0
          this.noDataChartSales()
          this.noDataChartSalesBranch()
          this.noDataChartGivepointsbyservice()
        }
        console.log(this.amount)
      }).catch(err => {
        console.log(err)
      })

      // get member
      let paramsMember = branchId ? '&lastBranch=' + branchId : ''
      await axios.get(this.DNS_IP + '/memberCard/get?shopId=' + this.shopId + paramsMember).then(res => {
        this.countMember = res.data.length
        if (Array.isArray(res.data)) {
          this.dataMember = res.data
        } else {

        }
        console.log('memberjajaja', res)
        const dataExportAllMember = this.dataMember.map((current) => {
          const key = current.lineUserId
          return { liffUserId: key, lineUserId: current.lineUserIdAsliff, name: current.LineName, picture: current.pictureUrl, CONDITION_TERM2: current.CONDITION_TERM2, birthDay: current.birthDay, gender: current.gender, tel: current.tel, nameCustomer: current.nameCustomer, levelName: current.levelName }
        }).filter(item2 => item2.CONDITION_TERM2 !== 'False')
        console.log('dataExportAllMember', dataExportAllMember)
        if (dataExportAllMember.length > 0) {
          this.export_data_allMember = dataExportAllMember
        }
        // lineUserIdAsliff
        // lineUserId
        // this.amount = res.data.reduce(
        //   (accumulator, currentValue) => accumulator + currentValue.amount,
        //   0
        // )
        // console.log(this.amount)
      }).catch(err => {
        console.log(err)
      })

      // get Newcustomer and old customer
      this.buyOnesMember = 0
      this.buyRepeatMember = 0
      let paramsGetcountMember = branchId ? '&masBranchID=' + branchId : ''
      await axios.get(this.DNS_IP + '/qrcode/repeatMemberAndOnes?shopId=' + this.shopId + '&status=used' + paramsGetcountMember).then(res => {
        // this.countReward = res.data
        console.log('repeatMemberAndOnes', res.data)
        if (Array.isArray(res.data)) {
          res.data.forEach((item) => {
            if (item.countMember === 1) {
              this.buyOnesMember += 1
              console.log('itemMember', item)
              this.dataBuyOnesMember.push(item)
            } else {
              this.buyRepeatMember += 1
              this.dataBuyRepeatsMember.push(item)
            }
          })
        }
        const resultExportOnesMember = this.dataBuyOnesMember.map((current) => {
          const key = current.liffUserId
          return { liffUserId: key, lineUserId: current.lineUserId, name: current.name, picture: current.picture, CONDITION_TERM2: current.CONDITION_TERM2 }
        }).filter(item2 => item2.CONDITION_TERM2 !== 'False')

        const resultExportRepeatsMember = this.dataBuyRepeatsMember.map((current) => {
          const key = current.liffUserId
          return { liffUserId: key, lineUserId: current.lineUserId, name: current.name, picture: current.picture, CONDITION_TERM2: current.CONDITION_TERM2 }
        }).filter(item2 => item2.CONDITION_TERM2 !== 'False')
        console.log('resultExportOnesMember', resultExportOnesMember)
        console.log('resultExportRepeatsMember', resultExportRepeatsMember)
        console.log('this.dataBuyRepeatsMember', this.dataBuyRepeatsMember)
        console.log('this.dataBuyOnesMember', this.dataBuyOnesMember)
        if (resultExportOnesMember.length > 0) {
          this.export_data_buyOneMember = resultExportOnesMember
        }
        if (resultExportRepeatsMember.length > 0) {
          this.export_data_buyRepeatMember = resultExportRepeatsMember
        }
        console.log('this.export_data_buyRepeatMember', this.export_data_buyRepeatMember)
        console.log('this.export_data_buyOneMember', this.export_data_buyOneMember)
        // this.amount = res.data.reduce(
        //   (accumulator, currentValue) => accumulator + currentValue.amount,
        //   0
        // )
        // console.log(this.amount)
      }).catch(err => {
        console.log(err)
      })
    },
    async getDatafilter (startday1, endday1, startday2, endday2, branchId) {
      this.countMember = null
      this.amount = null
      this.newMember = 0
      this.oldMember = 0
      // get sales ชุด 1
      let params = branchId ? '&masBranchID=' + branchId : ''
      console.log(params)
      await axios.get(this.DNS_IP + '/qrcode/get?status=used&shopId=' + this.shopId + '&status=used' + '&last_date_end=' + endday1 + '&last_date_start=' + startday1 + params).then(res => {
        console.log('getDatafilterSales1', res.data)
        if (Array.isArray(res.data)) {
          this.salesData = res.data
          this.updateSaleChartData()
          this.updateChartSalesBranch()
          this.updateChartSalesService()
          this.updateChartGivepointsbyservice()
          this.amountSales1 = res.data.reduce(
            (accumulator, currentValue) => accumulator + currentValue.amount, 0).toFixed(2)
        } else {
          this.amountSales1 = 0
          this.nodateChartSalesService()
          this.noDataChartSales()
          this.noDataChartSalesBranch()
          this.noDataChartGivepointsbyservice()
        }
      }).catch(err => {
        console.log(err)
      })

      // get sales ชุด 2
      if (startday2 && endday2) {
        await axios.get(this.DNS_IP + '/qrcode/get?status=used&shopId=' + this.shopId + '&status=used' + '&last_date_end=' + endday2 + '&last_date_start=' + startday2 + params).then(res => {
          console.log('getDatafilterSales2', res.data)
          if (Array.isArray(res.data)) {
            this.amountSales2 = res.data.reduce(
              (accumulator, currentValue) => accumulator + currentValue.amount, 0)
          } else {
            this.amountSales2 = 0
          }
          this.amountSales1 === this.amountSales2 ? this.trendUpSales = 'grey' : this.amountSales1 > this.amountSales2 ? this.trendUpSales = 'green' : this.trendUpSales = 'red'
          if (this.amountSales2 === 0) {
            this.diffPercentSales = this.amountSales1
          } else {
            console.log('eiei', this.amountSales1, this.amountSales2)
            this.diffPercentSales = ((this.amountSales1 - this.amountSales2) / this.amountSales2) * 100 + '%'
          }
          // parseFloat(this.diffPercentSales).toFixed(2)
          console.log(this.amountSales1)
          console.log(this.amountSales2)
          console.log('diffPercentSales', this.diffPercentSales)
        }).catch(err => {
          console.log(err)
        })
      }

      // get member ชุด 1
      let paramsMember = branchId ? '&lastBranch=' + branchId : ''
      console.log(params)
      await axios.get(this.DNS_IP + '/memberCard/get?shopId=' + this.shopId + '&create_date_start=' + startday1 + paramsMember).then(res => {
        console.log('getDatafilterMemberSet1', res.data)
        if (Array.isArray(res.data)) {
          this.countMemberSet1 = res.data.length
          this.countReward = res.data
        } else {
          this.countMemberSet1 = 0
        }
      }).catch(err => {
        console.log(err)
      })

      // get member ชุด 2
      if (startday2 && endday2) {
        await axios.get(this.DNS_IP + '/memberCard/get?shopId=' + this.shopId + '&create_date_start=' + startday2 + paramsMember).then(res => {
          if (Array.isArray(res.data)) {
            this.countMemberSet2 = res.data.length
          } else {
            this.countMemberSet2 = 0
          }
          this.countMemberSet1 === this.countMemberSet2 ? this.trendUpMember = 'grey' : this.countMemberSet1 > this.countMemberSet2 ? this.trendUpMember = 'green' : this.trendUpMember = 'red'
          if (this.countMemberSet2 === 0) {
            this.diffPercentMember = this.countMemberSet1
          } else {
            this.diffPercentMember = ((this.countMemberSet1 - this.countMemberSet2) / this.countMemberSet2) * 100 + '%'
          }
          this.show = true
          console.log('getDatafilterMemberSet2', res.data)
          console.log('diffPercentMember', this.diffPercentMember)
        }).catch(err => {
          console.log(err)
        })
      }

      // get member ชุด 1
      this.oldMemberSet1 = 0
      this.newMemberSet1 = 0
      let paramsOldMember = branchId ? '&lastBranch=' + branchId : ''
      await axios.get(this.DNS_IP + '/qrcode/NewandOldMember?shopId=' + this.shopId + '&status=used' + '&last_date_start=' + startday1 + '&last_date_end=' + endday1 + paramsOldMember).then(res => {
        console.log('getDataOldMemberSet1', res.data)
        let newMemberCheck = []
        let oldMember = []
        if (Array.isArray(res.data)) {
          res.data.forEach(async (item) => {
            if (item.countMember === 1) {
              newMemberCheck.push(item)
            } else {
              this.oldMemberSet1 += 1
              oldMember.push(item)
            }
          })
          console.log('oldMember', oldMember)
          this.export_data_oldMember = oldMember.map((current) => {
            const key = current.liffUserId
            return { liffUserId: key, lineUserId: current.lineUserId, name: current.name, picture: current.picture, CONDITION_TERM2: current.CONDITION_TERM2 }
          }).filter(item2 => item2.CONDITION_TERM2 !== 'False')
          console.log('export_data_oldMember', this.export_data_oldMember)
          if (newMemberCheck.length > 0) {
            this.getDataforCheckNewMemberSet1(newMemberCheck, endday1, branchId)
          }
        } else {
          this.oldMemberSet1 = 0
          this.newMemberSet1 = 0
        }
      }).catch(err => {
        console.log(err)
      })
      // get member ชุด 2
      if (startday2 && endday2) {
        this.oldMemberSet2 = 0
        await axios.get(this.DNS_IP + '/qrcode/NewandOldMember?shopId=' + this.shopId + '&status=used' + '&last_date_start=' + startday2 + paramsOldMember).then(res => {
          console.log('getDataOldMemberSet2', res.data)
          let newMemberCheck = []
          if (Array.isArray(res.data)) {
            res.data.forEach(async (item) => {
              if (item.countMember === 1) {
                newMemberCheck.push(item)
              } else {
                this.oldMemberSet2 += 1
              }
            })
            if (newMemberCheck.length > 0) {
              this.getDataforCheckNewMemberSet2(newMemberCheck, endday2, branchId)
            }
            // res.data.forEach(async (item) => {
            //   if (item.countMember === 1) {
            //     newMemberCheck.push(item)
            //   // this.buyOnesMember += 1
            //   } else {
            //     this.oldMemberSet2 += 1
            //   }
            // })
            // this.oldMemberSet1 === this.oldMemberSet2 ? this.trendUpOldMember = 'grey' : this.oldMemberSet1 > this.oldMemberSet2 ? this.trendUpOldMember = 'green' : this.trendUpOldMember = 'red'
            // if (this.oldMemberSet1 === 0) {
            //   this.diffPercentOldMember = this.oldMemberSet1
            // } else {
            //   this.diffPercentOldMember = ((this.oldMemberSet1 - this.oldMemberSet2) / this.oldMemberSet2) * 100 + '%'
            // }
          } else {
            this.oldMemberSet2 = 0
            this.newMemberSet2 = 0
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    async filterFunc () {
      // if (this.dates2) {
      //   this.dates2.sort((a, b) => {
      //     const timeA = new Date(a)
      //     const timeB = new Date(b)
      //     return timeB - timeA
      //   })
      //   let startday2 = this.dates[0]
      //   let endday2 = this.dates[1]
      // }
      // let startday1 = this.dates[0]
      // let endday1 = this.dates[1]
      // let startday2 = this.dates2[1]
      // let endday2 = this.dates2[1]
      // console.log('sfdfdfdf', startday1)
      // console.log('sfdfdfdf', endday1)
      // console.log('sfdfdfdf', startday2)
      // console.log('sfdfdfdf', endday2)
      if (this.dates2 && this.showCalendar2 === true) {
        this.dateShow = moment(this.dates2[0], 'YYYY-MM-DD').lang('th').format('ll')
        this.dateShow2 = moment(this.dates2[1], 'YYYY-MM-DD').lang('th').format('ll')
        this.dates.sort((a, b) => {
          const timeA = new Date(a)
          const timeB = new Date(b)
          return timeB - timeA
        })
        this.dates2.sort((a, b) => {
          const timeA = new Date(a)
          const timeB = new Date(b)
          return timeB - timeA
        })
        let startday1 = this.dates[0]
        let endday1 = this.dates[1]
        let startday2 = this.dates2[0]
        let endday2 = this.dates2[1]
        console.log('dates2have')
        this.getDatafilter(startday1, endday1, startday2, endday2, this.branchIdGlobal)
        this.filter = true
        this.specificDate = true
      } else {
        console.log('fffff2')
        this.dates.sort((a, b) => {
          const timeA = new Date(a)
          const timeB = new Date(b)
          return timeB - timeA
        })
        let startday1 = this.dates[0]
        let endday1 = this.dates[1]
        this.getDatafilter(startday1, endday1, null, null, this.branchIdGlobal)
        this.filter = null
        console.log('sfdfdfdf', startday1)
        console.log('sfdfdfdf', this.specificDate)
      }
      this.closeDialogDate()
    },
    async getDataforCheckNewMemberSet1 (newMemberCheck, endday1, branchId) {
      console.log('newMemberCheck', newMemberCheck)
      console.log('endday1', endday1)
      let paramsNewMember = branchId ? '&lastBranch=' + branchId : ''
      await axios.get(this.DNS_IP + '/qrcode/checkNewCustomer?shopId=' + this.shopId + '&first_time_get_point=' + endday1 + paramsNewMember).then(res => {
        console.log('checkNewCustomer', res.data)
        // let newMember = []
        let dataNewMember = []
        let oldMember = []
        if (Array.isArray(res.data)) {
          newMemberCheck.forEach((item) => {
            console.log('1111', item)
            const isOldMember = res.data.some((item2) => item.liffUserId === item2.LAST_USER)
            if (isOldMember) {
              this.oldMemberSet1 += 1
            } else {
              this.newMemberSet1 += 1
              dataNewMember.push(item)
            }
          })
          if (oldMember.length > 0) {
            this.export_data_oldMember = oldMember.map((current) => {
              const key = current.liffUserId
              return { liffUserId: key, lineUserId: current.lineUserId, name: current.name, picture: current.picture, CONDITION_TERM2: current.CONDITION_TERM2 }
            }).filter(item2 => item2.CONDITION_TERM2 !== 'False')
          }
          console.log('getDataforCheckNewMemberSet1this.export_data_oldMember', this.export_data_oldMember)
        } else {
          this.newMemberSet1 = newMemberCheck.length
        }
        console.log('ezportdataNewMember', dataNewMember)
        if (dataNewMember.length > 0) {
          this.export_data_newMember = dataNewMember.map((current) => {
            const key = current.liffUserId
            return { liffUserId: key, lineUserId: current.lineUserId, name: current.name, picture: current.picture, CONDITION_TERM2: current.CONDITION_TERM2 }
          }).filter(item2 => item2.CONDITION_TERM2 !== 'False')
        }
        console.log('export_data_newMember', this.export_data_newMember)
        // this.oldMemberSet1 === this.oldMemberSet2 ? this.trendUpOldMember = 'grey' : this.oldMemberSet1 > this.oldMemberSet2 ? this.trendUpOldMember = 'green' : this.trendUpOldMember = 'red'
        // if (this.oldMemberSet1 === 0) {
        //   this.diffPercentOldMember = this.oldMemberSet1
        // } else {
        //   this.diffPercentOldMember = ((this.oldMemberSet1 - this.oldMemberSet2) / this.oldMemberSet2) * 100 + '%'
        // }
        // console.log('newMemberSet1ja', this.newMemberSet1)
      }).catch(err => {
        console.log(err)
      })
    },
    async getDataforCheckNewMemberSet2 (newMemberCheck, endday2, branchId) {
      console.log('newMemberCheck2', newMemberCheck)
      console.log('endday2', endday2)
      let paramsNewMember2 = branchId ? '&lastBranch=' + branchId : ''
      await axios.get(this.DNS_IP + '/qrcode/checkNewCustomer?shopId=' + this.shopId + '&first_time_get_point=' + endday2 + paramsNewMember2).then(res => {
        console.log('checkNewCustomer2', res.data)
        // let newMember = []
        if (Array.isArray(res.data)) {
          newMemberCheck.forEach((item) => {
            console.log('2222')
            const isOldMember = res.data.some((item2) => item.liffUserId === item2.LAST_USER)
            if (isOldMember) {
              this.oldMemberSet2 += 1
            } else {
              this.newMemberSet2 += 1
            }
          })
        } else {
          this.newMemberSet2 = newMemberCheck.length
        }
        // old member
        // this.oldMemberSet1 = 0
        // this.oldMemberSet2 = 2
        // this.newMemberSet1 = 0
        // this.newMemberSet2 = 2
        this.oldMemberSet1 === this.oldMemberSet2 ? this.trendUpOldMember = 'grey' : this.oldMemberSet1 > this.oldMemberSet2 ? this.trendUpOldMember = 'green' : this.trendUpOldMember = 'red'
        if (this.oldMemberSet2 === 0) {
          this.diffPercentOldMember = this.oldMemberSet1
        } else {
          this.diffPercentOldMember = ((this.oldMemberSet1 - this.oldMemberSet2) / this.oldMemberSet2) * 100 + '%'
        }
        // new member
        this.newMemberSet1 === this.newMemberSet2 ? this.trendUpNewMember = 'grey' : this.newMemberSet1 > this.newMemberSet2 ? this.trendUpNewMember = 'green' : this.trendUpNewMember = 'red'
        if (this.newMemberSet2 === 0) {
          this.diffPercentNewMember = this.newMemberSet1
        } else {
          this.diffPercentNewMember = ((this.newMemberSet1 - this.newMemberSet2) / this.newMemberSet2) * 100 + '%'
        }
        console.log('diffPercentOldMember', this.diffPercentOldMember)
        console.log('this.oldMemberSet1', this.oldMemberSet1)
        console.log('this.oldMemberSet2', this.oldMemberSet2)
        console.log('this.newMemberSet1', this.newMemberSet1)
        console.log('this.newMemberSet2', this.newMemberSet2)
        // console.log('newMemberSet1ja', this.newMemberSet2)
      }).catch(err => {
        console.log(err)
      })
    },
    renderChartSales () {
      console.log('renderChartSales')
      let label = []
      let data = []
      if (Array.isArray(this.salesData)) {
        this.salesData.sort((a, b) => {
          const timeA = new Date(a.LAST_DATE)
          const timeB = new Date(b.LAST_DATE)
          return timeA - timeB
        }).map(a => {
          a.mounthYear = moment(a.LAST_DATE).format('MM/YYYY')
        })
        const result = Object.values(this.salesData.reduce((accumulator, current) => {
          const key = current.mounthYear
          if (!accumulator[key]) {
            accumulator[key] = { mounthYear: key, amount: current.amount }
          } else {
            accumulator[key].amount += current.amount
          }
          return accumulator
        }, {}))
        result.forEach((a) => {
          label.push(a.mounthYear)
          data.push(a.amount)
        })
      } else {
        console.log('dddddd')
        label.push('ไม่มีข้อมูล')
        data.push('ไม่มีข้อมูล')
      }

      console.log('result22222', label)
      // this.salesData.
      console.log('sort', this.salesData)
      const ctx = document.getElementById('myChart').getContext('2d')
      this.myChartSales = new Chart(ctx, {
        type: 'line',
        data: {
          labels: label,
          datasets: [{
            label: 'ยอดขาย',
            data: data,
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            pointBackgroundColor: 'rgba(255, 99, 132, 1)',
            borderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 2,
            pointStyle: 'circle',
            lineTension: 0.1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                let label = data.datasets[tooltipItem.datasetIndex].label || ''
                if (label) {
                  label += ': '
                }
                label += tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                label += ' บาท'
                return label
              }
            }
          },
          plugins: {
            datalabels: {
              display: false
            }
          },
          pointLabelFontSize: 0,
          scales: {
            x: {
              display: false // Set display to false to hide the x-axis
            },
            xAxes: [{
              // gridLines: {
              //   color: 'rgba(0, 0, 0, 0)'
              // },
              // ticks: {
              //   autoSkip: true,
              //   maxTicksLimit: 4
              // }
              display: false
            }],
            yAxes: [{
              // gridLines: {
              //   color: 'rgba(0, 0, 0, 0)'
              //
              ticks: {
                beginAtZero: false,
                autoSkip: true,
                maxTicksLimit: 6,
                callback: function (value, index, values) {
                  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
              }
            }]
          }
        }
      })
      this.showChartSales = true
      console.log('myChart', this.myChartSales)
    },
    renderChartSalesBranch () {
      // this.salesData
      let label = []
      let data = []
      if (Array.isArray(this.salesData)) {
        const result = Object.values(this.salesData.reduce((accumulator, current) => {
          const key = current.masBranchName
          if (!accumulator[key]) {
            accumulator[key] = { masBranchName: key, amount: current.amount }
          } else {
            accumulator[key].amount += current.amount
          }
          return accumulator
        }, {}))
        console.log('result1', result.sort((item, item2) => item2.amount - item.amount))
        if (result.length < 10) {
          this.dataSaleByBranch = result.sort((item, item2) => item2.amount - item.amount)
          result.forEach((a) => {
            label.push(a.masBranchName)
            data.push(a.amount)
          })
        } else {
          this.dataSaleByBranch = result.sort((item, item2) => item2.amount - item.amount)
          result.sort((item, item2) => item2.amount - item.amount).forEach((a) => {
            label.push(a.masBranchName)
            data.push(a.amount)
          })
          console.log('sort33333', result)
        }
      }
      // console.log()
      // label.push('กรุงเทพ', 'นนทบุรี', 'ฟิวเจอร์พาค รังสิต', 'กรุงเทพ', 'นนทบุรี', 'ฟิวเจอร์พาค รังสิต', 'กรุงเทพ', 'นนทบุรี', 'นนทบุรี')
      // data.push(60000000, 50000000, 4000000, 60000000, 50000000, 4000000, 50000000, 4000000, 10000000)
      // console.log('tet', data)
      // console.log('tet', label)
      this.checkMoreBranchten = true
      let labelShowForlengMoreten = null
      let dataShowForlengMoreten = null
      if (data.length > 10) {
        this.checkMoreBranchten = true
        labelShowForlengMoreten = label.slice(0, 10)
        dataShowForlengMoreten = data.slice(0, 10)
      } else {
        this.checkMoreBranchten = false
      }
      this.itemsBranchAutocomplete = label
      const ctx = document.getElementById('myChartBar').getContext('2d')
      this.myChartSalesBranch = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.checkMoreBranchten === true ? labelShowForlengMoreten : label,
          datasets: [{
            label: 'ยอดขาย',
            data: this.checkMoreBranchten === true ? dataShowForlengMoreten : data,
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 159, 64, 0.2)',
              'rgba(255, 205, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(201, 203, 207, 0.2)'
            ],
            borderColor: [
              'rgb(255, 99, 132)',
              'rgb(255, 159, 64)',
              'rgb(255, 205, 86)',
              'rgb(75, 192, 192)',
              'rgb(54, 162, 235)',
              'rgb(153, 102, 255)',
              'rgb(201, 203, 207)'
            ],
            pointBackgroundColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 2,
            barThickness: 30,
            borderRadius: 30
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          pointLabelFontSize: 0,
          onClick: (event, elements) => {
            const xAxis = this.myChartSalesBranch.scales['x-axis-0']
            const mouseX = event.clientX - this.myChartSalesBranch.canvas.getBoundingClientRect().left
            const clickedIndex = xAxis.getValueForPixel(mouseX)
            // const mouseX = event.clientX - this.myChartSalesBranch.canvas.getBoundingClientRect().left
            // const clickedLabel = xAxis.getLabelForValue(xAxis.getValueForPixel(mouseX))
            this.handleChartDoubleClick(xAxis._labelItems[clickedIndex].label, 'saleBranch')
            // this.filterSalesBybranch(xAxis._labelItems[clickedIndex].label)
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                let label = data.datasets[tooltipItem.datasetIndex].label || ''
                if (label) {
                  label += ': '
                }
                label += tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                label += ' บาท'
                return label
              }
            }
          },
          legend: {
            display: false // Set display to false to hide the legend
          },
          scales: {
            xAxes: [{
              // gridLines: {
              //   color: 'rgba(0, 0, 0, 0)'
              // },
              // ticks: {
              //   autoSkip: true,
              //   maxTicksLimit: 4
              // }
              display: true
            }],
            yAxes: [{
              // gridLines: {
              //   color: 'rgba(0, 0, 0, 0)'
              //
              ticks: {
                beginAtZero: false,
                autoSkip: true,
                maxTicksLimit: 6,
                callback: function (value, index, values) {
                  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
              }
            }]
          },
          plugins: {
            legend: {
              display: false // Hide the legend
            },
            datalabels: {
              color: '#fff', // Text color of the labels
              // align: 'top',
              anchor: 'end',
              backgroundColor: 'rgba(54, 162, 235, 0.6)', // Background color of the labels
              borderRadius: 4, // Border radius of the labels
              font: {
                size: 12, // Font size of the labels
                weight: 'bold' // Font weight of the labels
              },
              formatter: function (value, context) {
                return Number(value.toString()).toLocaleString() // Format the label value with commas
              }
            }
          }
        }
      })
      console.log(this.myChartSalesBranch)
      console.log(data)
    },
    renderChartSalesService () {
      let label = []
      let data = []
      if (Array.isArray(this.salesData)) {
        const result = Object.values(this.salesData.reduce((accumulator, current) => {
          const key = current.productExchangeRateName
          if (!accumulator[key]) {
            accumulator[key] = { productExchangeRateName: key, amount: current.amount }
          } else {
            accumulator[key].amount += current.amount
          }
          return accumulator
        }, {}))
        console.log('renderChartSalesService1', result)
        result.forEach((a) => {
          label.push(a.productExchangeRateName)
          data.push(a.amount)
        })
      } else {
        label = []
        data = []
      }
      console.log('renderChartSalesBranch', data)
      console.log('renderChartSalesBranch', label)
      const ctx = document.getElementById('myChartline').getContext('2d')
      this.myChartSalesService = new Chart(ctx, {
        type: 'horizontalBar',
        data: {
          labels: label,
          datasets: [{
            label: 'ยอดขาย',
            data: data,
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 159, 64, 0.2)',
              'rgba(255, 205, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(201, 203, 207, 0.2)'
            ],
            borderColor: [
              'rgb(255, 99, 132)',
              'rgb(255, 159, 64)',
              'rgb(255, 205, 86)',
              'rgb(75, 192, 192)',
              'rgb(54, 162, 235)',
              'rgb(153, 102, 255)',
              'rgb(201, 203, 207)'
            ],
            pointBackgroundColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 2,
            barThickness: 30
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          pointLabelFontSize: 0,
          borderWidth: 2,
          borderRadius: 10,
          borderSkipped: false,
          onClick: (event, elements) => {
            const yAxis = this.myChartSalesService.scales['y-axis-0']
            const mouseY = event.clientY - this.myChartSalesService.canvas.getBoundingClientRect().top - 14
            console.log('mouseY', mouseY)
            const clickedIndex = yAxis.getValueForPixel(mouseY)
            // const clickedIndex = yAxis.getValueForPixel(mouseY)
            // const clickedLabel = yAxis.getLabelForValue(clickedIndex)
            this.handleChartDoubleClick(yAxis._labelItems[clickedIndex].label, 'saleService')
            // console.log('Clicked label:', yAxis)
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                let label = data.datasets[tooltipItem.datasetIndex].label || ''
                if (label) {
                  label += ': '
                }
                label += tooltipItem.xLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                label += ' บาท'
                console.log('บาท', label)
                return label
              }
            }
          },
          scales: {
            xAxes: [{
              ticks: {
                autoSkip: true,
                maxTicksLimit: 6,
                callback: function (value, index, values) {
                  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
              }
            }]
          },
          plugins: {
            legend: {
              display: false // Hide the legend
            },
            datalabels: {
              color: '#fff', // Text color of the labels
              backgroundColor: 'rgba(54, 162, 235, 0.6)', // Background color of the labels
              borderRadius: 4, // Border radius of the labels
              align: 'right',
              anchor: 'center',
              font: {
                size: 12, // Font size of the labels
                weight: 'bold' // Font weight of the labels
              },
              formatter: function (value, context) {
                return Number(value.toString()).toLocaleString() // Format the label value with commas
              }
            }
          }
        }
      })
      console.log(this.myChartSalesBranch)
    },
    renderChartGivepointsbyservice () {
      let label = []
      let data = []
      if (Array.isArray(this.salesData)) {
        const result = Object.values(this.salesData.reduce((accumulator, current) => {
          const key = current.productExchangeRateName
          if (!accumulator[key]) {
            accumulator[key] = { productExchangeRateName: key, point: current.point }
          } else {
            accumulator[key].point += current.point
          }
          return accumulator
        }, {}))
        console.log('renderChartGivepointsbyservice', result)
        result.forEach((a) => {
          label.push(a.productExchangeRateName)
          data.push(a.point)
        })
      } else {
        label = ['ไม่มีข้อมูล']
        data = ['ไม่มีข้อมูล']
      }
      const ctx = document.getElementById('myChartDoughnut').getContext('2d')
      this.myChartGivepointsbyservice = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: label,
          datasets: [{
            label: 'test',
            data: data,
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 159, 64, 0.2)',
              'rgba(255, 205, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(201, 203, 207, 0.2)'
            ],
            borderColor: [
              'rgb(255, 99, 132)',
              'rgb(255, 159, 64)',
              'rgb(255, 205, 86)',
              'rgb(75, 192, 192)',
              'rgb(54, 162, 235)',
              'rgb(153, 102, 255)',
              'rgb(201, 203, 207)'
            ],
            pointBackgroundColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 2,
            pointLabelFontSize: 0
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          pointLabelFontSize: 0,
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                const value = data.datasets[0].data[tooltipItem.index]
                return value.toLocaleString()
              }
            }
          },
          legend: {
            position: 'bottom', // Position the legend on the right side
            align: 'center', // Align the legend items to the start
            labels: {
              boxWidth: 15 // Adjust the width of the legend color boxes
            }
          },
          onClick: (event, elements) => {
            if (elements && elements.length > 0) {
              const clickedElementIndex = elements[0]._index
              const clickedLabel = label[clickedElementIndex]
              // const clickedValue = data[clickedElementIndex]
              // console.log(clickedLabel)
              this.handleChartDoubleClick(clickedLabel, 'givePointByService')
            // console.log('Clicked Label:', clickedLabel)
            // console.log('Clicked Value:', clickedValue)
            }
          },
          plugins: {
            datalabels: {
              color: '#fff', // Text color of the labels
              backgroundColor: 'rgba(54, 162, 235, 0.6)', // Background color of the labels
              borderRadius: 4, // Border radius of the labels
              font: {
                size: 12, // Font size of the labels
                weight: 'bold' // Font weight of the labels
              },
              formatter: function (value, context) {
                return Number(value.toString()).toLocaleString() // Format the label value with commas
              }
            }
          }
          // scales: {
          //   xAxes: [{
          //     gridLines: {
          //       color: 'rgba(0, 0, 0, 0)'
          //     },
          //     ticks: {
          //       autoSkip: true,
          //       maxTicksLimit: 4
          //     }
          //   }],
          //   yAxes: [{
          //     gridLines: {
          //       color: 'rgba(0, 0, 0, 0)'
          //     },
          //     ticks: {
          //       beginAtZero: false,
          //       autoSkip: true,
          //       maxTicksLimit: 6
          //     }
          //   }]
          // }
        }
      })
      console.log(this.myChartGivepointsbyservice)
    },
    trendMember (item) {
      let icon = null
      if (item === 'member') {
        icon = this.countMemberSet1 === this.countMemberSet2 ? 'mdi-minus-thick' : this.countMemberSet1 > this.countMemberSet2 ? 'mdi-trending-up' : 'mdi-trending-down'
      } else if (item === 'sales') {
        icon = this.amountSales1 === this.amountSales2 ? 'mdi-minus-thick' : this.amountSales1 > this.amountSales2 ? 'mdi-trending-up' : 'mdi-trending-down'
      } else if (item === 'newMember') {
        icon = this.newMemberSet1 === this.newMemberSet2 ? 'mdi-minus-thick' : this.newMemberSet1 > this.newMemberSet2 ? 'mdi-trending-up' : 'mdi-trending-down'
      } else if (item === 'oldMember') {
        icon = this.oldMemberSet1 === this.oldMemberSet2 ? 'mdi-minus-thick' : this.oldMemberSet1 > this.oldMemberSet2 ? 'mdi-trending-up' : 'mdi-trending-down'
      }
      // let icon = this.countMemberSet1 === this.countMemberSet2 ? 'mdi-minus-thick' : this.countMemberSet1 > this.countMemberSet2 ? 'mdi-trending-up' : 'mdi-trending-down'
      return icon
    },
    updateSaleChartData () {
      console.log('updateSaleChartData', this.salesData)
      this.salesData.sort((a, b) => {
        const timeA = new Date(a.LAST_DATE)
        const timeB = new Date(b.LAST_DATE)
        return timeA - timeB
      }).map(a => {
        a.mounthYear = moment(a.LAST_DATE).format('MM/YYYY')
      })
      const result = Object.values(this.salesData.reduce((accumulator, current) => {
        const key = current.mounthYear
        if (!accumulator[key]) {
          accumulator[key] = { mounthYear: key, amount: current.amount }
        } else {
          accumulator[key].amount += current.amount
        }
        return accumulator
      }, {}))
      let label = []
      let data = []
      result.forEach((a) => {
        label.push(a.mounthYear)
        data.push(a.amount)
      })
      this.myChartSales.data.datasets[0].data = data
      this.myChartSales.data.labels = label
      this.myChartSales.update()
      // console.log('this.myChartSales.data.datasets[0].data', this.myChartSales.data.datasets[0].data)
    },
    noDataChartSales () {
      console.log('tetetetet')
      this.myChartSales.data.datasets[0].data = [0]
      this.myChartSales.update()
    },
    updateChartSalesBranch () {
      console.log('updateChartSalesBranch')
      const result = Object.values(this.salesData.reduce((accumulator, current) => {
        const key = current.masBranchName
        if (!accumulator[key]) {
          accumulator[key] = { masBranchName: key, amount: current.amount }
        } else {
          accumulator[key].amount += current.amount
        }
        return accumulator
      }, {}))
      this.dataSaleByBranch = result
      console.log('updateChartSalesBranch222', result)
      let label = []
      let data = []
      result.forEach((a) => {
        label.push(a.masBranchName)
        data.push(a.amount)
      })
      this.myChartSalesBranch.data.datasets[0].data = data
      this.myChartSalesBranch.data.labels = label
      this.myChartSalesBranch.update()
    },
    noDataChartSalesBranch () {
      this.myChartSalesBranch.data.datasets[0].data = [0, 0]
      this.myChartSalesBranch.data.labels = []
      this.myChartSalesBranch.update()
    },
    updateChartGivepointsbyservice () {
      const result = Object.values(this.salesData.reduce((accumulator, current) => {
        const key = current.productExchangeRateName
        if (!accumulator[key]) {
          accumulator[key] = { productExchangeRateName: key, point: current.point }
        } else {
          accumulator[key].point += current.point
        }
        return accumulator
      }, {}))
      console.log('updateChartGivepointsbyservice', result)
      let label = []
      let data = []
      result.forEach((a) => {
        label.push(a.productExchangeRateName)
        data.push(a.point)
      })
      this.myChartGivepointsbyservice.data.datasets[0].data = data
      this.myChartGivepointsbyservice.data.labels = label
      this.myChartGivepointsbyservice.update()
    },
    noDataChartGivepointsbyservice () {
      this.myChartGivepointsbyservice.data.datasets[0].data = ['ไม่มีข้อมูล']
      this.myChartGivepointsbyservice.data.labels = ['ไม่มีข้อมูล']
      this.myChartGivepointsbyservice.update()
    },
    renderChartLevelMember () {
      const result = Object.values(this.dataMember.reduce((accumulator, current) => {
        const key = current.levelName
        if (!accumulator[key]) {
          accumulator[key] = { levelName: key, amount: 1 }
        } else {
          accumulator[key].amount += 1
        }
        return accumulator
      }, {}))
      let label = []
      let data = []
      result.forEach((a) => {
        label.push(a.levelName)
        data.push(a.amount)
      })
      console.log('resultMember', data)
      console.log('resultMemberlabel', label)
      const ctx = document.getElementById('myChartArea').getContext('2d')
      this.myChartLevelMember = new Chart(ctx, {
        type: 'pie',
        data: {
          labels: label,
          datasets: [{
            label: 'My First Dataset',
            data: data,
            backgroundColor: [
              'rgb(255, 99, 132)',
              'rgb(75, 192, 192)',
              'rgb(255, 205, 86)'
            ]
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          onClick: (event, elements) => {
            if (elements && elements.length > 0) {
              const clickedElementIndex = elements[0]._index
              const clickedLabel = label[clickedElementIndex]
              // const clickedValue = data[clickedElementIndex]
              this.handleChartDoubleClick(clickedLabel, 'levelMember')
              // this.filterMemberLevel(clickedLabel)
              // console.log('Clicked Label:', clickedLabel)
              // console.log('Clicked Value:', clickedValue)
            }
          },
          legend: {
            position: 'bottom', // Position the legend on the right side
            align: 'center', // Align the legend items to the start
            labels: {
              boxWidth: 15 // Adjust the width of the legend color boxes
            }
          },
          plugins: {
            datalabels: {
              color: '#fff', // Text color of the labels
              backgroundColor: 'rgba(54, 162, 235, 0.6)', // Background color of the labels
              borderRadius: 4, // Border radius of the labels
              font: {
                size: 12, // Font size of the labels
                weight: 'bold' // Font weight of the labels
              },
              formatter: (value, ctx) => {
                const dataset = ctx.chart.data.datasets[0]
                const total = dataset.data.reduce((acc, curr) => acc + curr, 0)
                const percentage = ((value / total) * 100).toFixed(1) + '%'
                return percentage
              }
            }
          }
        }
      })
    },
    updateChartSalesService () {
      const result = Object.values(this.salesData.reduce((accumulator, current) => {
        const key = current.productExchangeRateName
        if (!accumulator[key]) {
          accumulator[key] = { productExchangeRateName: key, amount: current.amount }
        } else {
          accumulator[key].amount += current.amount
        }
        return accumulator
      }, {}))
      console.log('renderChartSalesService1', result)
      let label = []
      let data = []
      result.forEach((a) => {
        label.push(a.productExchangeRateName)
        data.push(a.amount)
      })
      if (data.length === 2) {
        data.push('')
      }
      this.myChartSalesService.data.datasets[0].data = data
      this.myChartSalesService.data.labels = label
      this.myChartSalesService.update()
    },
    nodateChartSalesService () {
      this.myChartSalesService.data.datasets[0].data = []
      this.myChartSalesService.data.labels = []
      this.myChartSalesService.update()
    },
    filterMemberLevel (levelname) {
      let datafilter = this.dataMember.filter((item) => {
        return item.levelName === levelname
      })
      console.log(datafilter)
      let result = datafilter.map((item) => {
        return { liffUserId: item.lineUserId, lineUserId: item.lineUserIdAsliff, name: item.LineName, picture: item.LinePicture, CONDITION_TERM2: item.CONDITION_TERM2 }
      }).filter(item2 => item2.CONDITION_TERM2 !== 'False')
      console.log('datafilter', result)
      this.export_data = result
      this.snackbar = true
    },
    filterSalesBybranch (branchName) {
      // อยากได้ lineUserId ที่นั้นใช้สาขาที่เลือก
      console.log('branchName', branchName)
      let datafilter = this.salesData.filter((item) => {
        return item.masBranchName === branchName
      })

      console.log('datafilter,', datafilter)
      const result = Object.values(datafilter.reduce((accumulator, current) => {
        const key = current.liffUserId
        if (!accumulator[key]) {
          accumulator[key] = { liffUserId: key, lineUserId: current.lineUserId, name: current.name, picture: current.picture, CONDITION_TERM2: current.CONDITION_TERM2 }
        }
        return accumulator
      }, {})).filter((a) => a.name !== null)
      console.log('datafilterSalesBybranch', result)
      this.export_data = result
      this.snackbar = true
    },
    filterGivePointByservice (serviceName) {
      console.log('datafilterSalesBybranch', serviceName)
      // อยากได้ lineUserId ที่นั้นใช้บริการที่เลือก
      let datafilter = this.salesData.filter((item) => {
        return item.productExchangeRateName === serviceName
      })
      const result = Object.values(datafilter.reduce((accumulator, current) => {
        const key = current.liffUserId
        if (!accumulator[key]) {
          accumulator[key] = { liffUserId: key, lineUserId: current.lineUserId, name: current.name, picture: current.picture, CONDITION_TERM2: current.CONDITION_TERM2 }
        }
        return accumulator
      }, {})).filter(item2 => item2.CONDITION_TERM2 !== 'False')
      console.log('datafilterSalesBybranch', result)
      this.export_data = result
      this.snackbar = true
    },
    filterSalesByService (serviceName) {
      // อยากได้ lineUserId ที่นั้นใช้บริการที่เลือก
      let datafilter = this.salesData.filter((item) => {
        return item.productExchangeRateName === serviceName
      })
      console.log('datafilter', datafilter)
      const result = Object.values(datafilter.reduce((accumulator, current) => {
        const key = current.liffUserId
        if (!accumulator[key]) {
          accumulator[key] = { liffUserId: key, lineUserId: current.lineUserId, name: current.name, picture: current.picture, CONDITION_TERM2: current.CONDITION_TERM2 }
        }
        return accumulator
      }, {})).filter(item2 => item2.CONDITION_TERM2 !== 'False')
      console.log('datafilterSalesBybranch', result)
      this.export_data = result
      this.snackbar = true
    },
    exportBuyOnesMember () {
      console.log(this.dataBuyOnesMember)
      this.export_data_oneMember = this.dataBuyOnesMember
    },
    handleChartDoubleClick (data, type) {
      const currentTime = new Date().getTime()
      const timeThreshold = 300 // Adjust the threshold as needed (in milliseconds)

      if (currentTime - this.lastClickTime < timeThreshold) {
        // Double click action
        console.log(type)
        console.log('Double click', data)
        if (type === 'levelMember') {
          this.textExport = 'สมาชิกระดับ'
          this.textTypeExport = data
          console.log('this.textTypeExport', this.textTypeExport)
          this.filterMemberLevel(data)
        } else if (type === 'givePointByService') {
          this.textExport = 'สมาชิกบริการ'
          this.textTypeExport = data
          this.filterGivePointByservice(data)
        } else if (type === 'saleService') {
          this.textExport = 'สมาชิกบริการ'
          this.textTypeExport = data
          this.filterSalesByService(data)
        } else if (type === 'saleBranch') {
          this.textExport = 'สมาชิกสาขา'
          this.textTypeExport = data
          this.filterSalesBybranch(data)
        }
        // Reset the last click time
        this.lastClickTime = 0
      } else {
        // Single click action
        console.log('Single click')

        // Update the last click time
        this.lastClickTime = currentTime
      }
    },
    calPercent (a, item) {
      return ((item / a) * 100).toFixed(2)
    },
    checkMoreOrLess () {
      if (this.column === 'มากไปน้อย' && this.valuesBranchAutocomplete.length > 0) {
        // console.log('aaaaa')
        if (this.valuesBranchAutocomplete !== null) {
          // this.filterDataSaleByBranch = []
          this.filterDataSaleByBranch = this.dataSaleByBranch.filter((a) => {
            return this.valuesBranchAutocomplete.includes(a.masBranchName)
          }).sort((a, b) => b.amount - a.amount)
          console.log('this.มากไปน้อย', this.filterDataSaleByBranch)
        }
      } else if (this.column === 'น้อยไปมาก' && this.valuesBranchAutocomplete.length > 0) {
        if (this.valuesBranchAutocomplete !== null) {
          // this.filterDataSaleByBranch = []
          this.filterDataSaleByBranch = this.dataSaleByBranch.filter((a) => {
            return this.valuesBranchAutocomplete.includes(a.masBranchName)
          }).sort((a, b) => a.amount - b.amount)
          console.log('this.น้อยไปมาก', this.filterDataSaleByBranch)
        }
      } else {
        console.log('no have')
        if (this.column === 'มากไปน้อย') {
          this.filterDataSaleByBranch = this.dataSaleByBranch.sort((a, b) => b.amount - a.amount)
        } else if (this.column === 'น้อยไปมาก') {
          this.filterDataSaleByBranch = this.dataSaleByBranch.sort((a, b) => a.amount - b.amount)
        }
      }
      // console.log('this.filterDataSaleByBranchFinal', this.filterDat,aSaleByBranch)
    },
    exportData (item) {
      console.log(item.masBranchName)
      this.filterSalesBybranch(item.masBranchName)
      console.log(this.salesData)
    }
    // async getDataList () {
    //   this.dataReady = false
    //   // Clear Data ทุกครั้ง
    //   this.dataItem = []
    //   // Clear ช่องค้นหา
    //   this.searchAll = ''

    //   await axios
    //     .get(
    //       // eslint-disable-next-line quotes
    //       this.DNS_IP +
    //         // this.path +
    //         '/member/Member?shopId=' +
    //         this.session.data.shopId
    //     )
    //     .then(async response => {
    //       if (response.data.length > 0) {
    //         console.log('getData', response.data)
    //         this.dataReady = true
    //         this.dataItem = response.data
    //         console.log('this.dataItem', this.dataItem)
    //       } else {
    //         this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
    //         this.dataReady = true
    //       }
    //       this.export_data = response.data
    //       console.log('export_data', this.export_data)
    //       // แปลง JSON.parse() regisCustomFeild
    //       this.export_data.map((item) => {
    //         if (item.regisCustomFeild !== null) {
    //           item.regisCustomFeild = JSON.parse(item.regisCustomFeild)
    //         }
    //       })
    //       // console.log('this.export_data', this.export_data)
    //       let index = null
    //       index = this.export_data.findIndex(a => a.regisCustomFeild !== null)
    //       if (index) {
    //         this.export_data[index].regisCustomFeild.forEach((item, index) => {
    //           console.log('regisCustomFeild', item)
    //           const keyName2 = ${item.customFeildName}
    //           this.export_field[keyName2] = exelAnswer${index + 1}
    //         })

    //         this.export_data.map((item1) => {
    //           if (item1.regisCustomFeild) {
    //             item1.regisCustomFeild.forEach((item2, index) => {
    //               console.log('item2.value', index)
    //               const keyName1 = exelAnswer${index + 1}
    //               item1[keyName1] = item2.value
    //             })
    //           }
    //         })
    //       }

    //       console.log('export_data', this.export_data)
    //       console.log('export_fields', this.export_fields)
    //     })
    //     // eslint-disable-next-line handle-callback-err
    //     .catch(error => {
    //       console.log(error)
    //       //   this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
    //       this.dataReady = true
    //     })
    // },
    // async searchDataAll () {
    //   //
    //   //
    //   // สำหรับ ค้นหาแบบ LIKE Search
    //   // ต้องระบุ Field ที่จะส่งไปให้ตรงกับ Model
    //   //
    //   var search = '?name=' + this.searchAll + '&shopId=' + this.searchAll
    //   this.dataReady = false
    //   this.searchDataAllGlobal(
    //     this.DNS_IP,
    //     this.path,
    //     search,
    //     this.session.data.shopId,
    //     this.returnLink
    //   )
    // },
    // async getExportData () {
    //   console.log(this.session.data.shopId)
    //   await axios
    //     .get(
    //       'http://localhost:5001/get-history-activity/get?shopId=' +
    //         this.session.data.shopId
    //     )
    //     .then(async response => {
    //       console.log(response.data)
    //       this.export_data1 = response.data
    //     })
    //     .catch(error => {
    //       console.log(error)
    //       this.dataReady = true
    //     })
    // },
    // Export_LineUserId () {
    //   axios
    //     .get(
    //       this.DNS_IP + '/member/Member_Ex?shopId=' + this.session.data.shopId
    //     )
    //     .then(async response => {
    //       console.log(response.data)
    //       this.export_data1 = response.data
    //     })
    // },
    // async saerchDataAdvanced () {
    //   var search = ''
    //   var check = false

    //   for (var key in this.search) {
    //     check = true
    //     if (this.search[key]) {
    //       if (search !== '') {
    //         search += '&'
    //       }
    //       search += key + '=' + this.search[key]
    //     }

    //     if (
    //       this.search.last_date_start === '' &&
    //       this.search.last_date_end !== ''
    //     ) {
    //       check = false
    //       this.$swal('ผิดพลาด', 'กรุณาเลือกวันที่แก้ไข เริ่มต้น', 'error')
    //     }

    //     if (
    //       this.search.create_date_start === '' &&
    //       this.search.create_date_end !== ''
    //     ) {
    //       check = false
    //       this.$swal('ผิดพลาด', 'กรุณาเลือกวันที่สร้าง เริ่มต้น', 'error')
    //     }
    //   }
    //   if (check === true) {
    //     this.dataReady = false

    //     this.saerchDataAdvancedGlobal(
    //       this.DNS_IP,
    //       this.path,
    //       search,
    //       this.session.data.shopId,
    //       this.returnLink
    //     )
    //   } else {
    //     this.dataReady = true
    //   }
    // },
    // async getDataById (item) {
    //   console.log('item', this.session.data.shopId)
    //   this.fromUpdate.name = item.name
    //   this.fromUpdate.point = item.point
    //   this.fromUpdate.level = item.level
    //   this.fromUpdate.picture = item.picture
    //   this.fromUpdate.tel = item.tel
    //   this.fromUpdate.birthDay = item.birthDay
    //   let rs = await axios.get(
    //     this.DNS_IP +
    //       '/get-member-activity/get?lineUserId=' +
    //       item.liffUserId +
    //       '&shopId=' +
    //       this.session.data.shopId
    //   )
    //   this.memberActivity = rs.data
    //   console.log('ddddd', this.memberActivity)
    // },
    // async clearData () {
    //   for (var key in this.search) {
    //     if (this.search[key]) {
    //       this.search[key] = ''
    //     }
    //   }
    // }
  }
}
</script>
<style scope>
.container-overview{
  background-color: white;
  min-height: 132px;
  border-radius: 17px;
  padding: 20px;
}
canvas{
  background-color: rgb(255, 255, 255);
  height:300px;
  padding:0px;
}
.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
}
.centerText {
  display: flex;
  justify-content: center;
  align-items: end;
}
.chart-legend li span {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}
.mdi-download:before {
    content: "\F01DA";
    color: rgb(117, 117, 117) !important;
}
.v-text-field {
    padding: 0px 0px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/DashBoard.vue